import React, { useEffect, useState } from 'react';
import { useEventListener, useKeyPress } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { Button } from '../Button/styled';
import { IconName, StyledIcon as Icon } from '../Icons';
const RenderDefaultIcon = (isFullscreen, color, backgroundColor, styles) => (React.createElement(Icon, { style: styles.icon, "data-test": "FullscreenButton-Icon", className: "FullscreenButton-Icon", name: isFullscreen ? IconName.exitfullscreen : IconName.enterfullscreen, color, backgroundColor }));
export const FullscreenButton = ({ color, disabledColor, backgroundColor = 'transparent', className = '', playerInstance, customIcon = RenderDefaultIcon, styles = {
    button: null,
    icon: null,
}, }) => {
    var _a, _b;
    const FPress = useKeyPress('F');
    const fPress = useKeyPress('f');
    const [isFullscreen, setIsFullscreen] = useState(!!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.fullscreen));
    const disabled = !playerInstance;
    const { theme } = useTheme();
    const finalColor = color || ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.contrast1) || 'white';
    const finalDisabledColor = disabledColor || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.contrast4) || 'gray';
    const iconColor = !disabled ? finalColor : finalDisabledColor;
    useEventListener('fullscreenchanged', (event) => {
        setIsFullscreen(event.isFullscreen);
    }, playerInstance);
    const onClickHandler = (event) => {
        if (playerInstance && !disabled) {
            playerInstance.fullscreen = !playerInstance.fullscreen;
        }
        if (event)
            event.stopPropagation();
    };
    useEffect(() => {
        if (!fPress && !FPress)
            return;
        onClickHandler(null);
    }, [fPress, FPress]);
    return (React.createElement(Button, { style: styles.button, "data-test": "FullscreenButton-Button", testID: `${!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.fullscreen) ? 'maximize' : 'minimize'}_button`, className: `${className} FullscreenButton-Button`, onClick: onClickHandler, backgroundColor, disabled }, customIcon(isFullscreen, iconColor, backgroundColor, styles)));
};
//# sourceMappingURL=index.js.map